export const ML_SEARCH_EXPERIMENT_VARIANT = 'variant';

export const isMlSearchActive = (hasCasinoSearchService: boolean | undefined, experimentGroupId: string): boolean =>
    hasCasinoSearchService === true && experimentGroupId.toLowerCase() === ML_SEARCH_EXPERIMENT_VARIANT;
